<template>
  <PageWrapper
    :active-section="SECTION_COMMUNITY"
    :active-page="PAGE_COMMUNITY_CREATORS"
    title="Creators"
    sub-title=""
    :breadcrumbs="breadcrumbs"
    page-name="Creators"
    align="center"
    width="full"
  >
    <SmartFeed
      :source="useCreatorDirectoryFeedStore"
      load-more-behavior="auto"
    />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import {
  PAGE_COMMUNITY_CREATORS,
  SECTION_COMMUNITY,
} from "@/constants/nav-constants";
import { useCreatorDirectoryFeedStore } from "SmartFeed/stores/feed/creator-directory-feed-store";

export default {
  name: "CreatorsDirectory",
  components: {
    SmartFeed,
    PageWrapper,
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_COMMUNITY_CREATORS,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
      ];
    },
  },
  methods: {
    useCreatorDirectoryFeedStore,
  },
};
</script>
